export const RiveAnimations = {
  Confetti: () => import('@/assets/animations/rive/confetti.riv'),

  TravelHeartAnimatedBullet: () =>
    import('@/assets/animations/rive/exploding-hearts.riv'),

  ProviderAarhuscharter: () =>
    import('@/assets/animations/rive/provider-tag/aarhuscharter.riv'),

  ProviderBravotours: () =>
    import('@/assets/animations/rive/provider-tag/bravotours.riv'),

  ProviderDanski: () =>
    import('@/assets/animations/rive/provider-tag/danski.riv'),

  ProviderNortlander: () =>
    import('@/assets/animations/rive/provider-tag/nortlander.riv'),

  ProviderPrimotours: () =>
    import('@/assets/animations/rive/provider-tag/primotours.riv'),

  ProviderSnowtours: () =>
    import('@/assets/animations/rive/provider-tag/snowtours.riv'),

  ProviderSuncharter: () =>
    import('@/assets/animations/rive/provider-tag/suncharter.riv'),

  SlideInBottom: () => import('@/assets/animations/rive/slide-in-bottom.riv'),

  SlideInLeft: () => import('@/assets/animations/rive/slide-in-left.riv'),

  SlideInTop: () => import('@/assets/animations/rive/slide-in-top.riv'),
} as const;

export const loadRiveAnimation = async (
  name: RiveAnimationName,
): Promise<string> => {
  const { default: src } = await RiveAnimations[name]();

  return src;
};
